// src/app/core/services/auth-microsoft.service.ts
import { Inject, Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult, InteractionRequiredAuthError } from '@azure/msal-browser';
import { RestService } from './rest.service';
import { AZURE_CLIENT_ID } from '../../app.module';

@Injectable({
    providedIn: 'root',
})
export class AuthMicrosoftService {
    constructor(
        private msal: MsalService,
        @Inject(RestService) private restService: RestService,
    ) {}

    get isActivated(): boolean {
        return !!AZURE_CLIENT_ID && AZURE_CLIENT_ID !== '__AZURE_CLIENT_ID__';
    }

    //Microsoft Login
    login() {
        // Déclenche le redirect AAD (tu peux ajouter ton/tes scopes d’API si tu en as un)
        return this.msal.loginRedirect({
            scopes: ['openid', 'profile', 'email'],
            prompt: 'select_account',
        });
    }

    microsoftActiveAccount() {
        return this.msal.instance.getActiveAccount();
    }

    /** Récupère un id_token (ou access_token si tu exposes une API AAD) */
    async microsoftAcquireToken(options?: { useAccessToken?: boolean }): Promise<string> {
        const account = this.microsoftActiveAccount();
        if (!account) throw new Error('No active AAD account');

        try {
            const res: AuthenticationResult = await this.msal.instance.acquireTokenSilent({
                account,
                scopes: ['openid', 'profile', 'email'], // ← remplace par ['api://.../scope'] si tu valides un access_token côté back
            });
            return options?.useAccessToken ? res.accessToken : res.idToken;
        } catch (e) {
            if (e instanceof InteractionRequiredAuthError) {
                await this.login(); // relance un redirect si nécessaire
            }
            throw e;
        }
    }

    /**
     * Envoie le token Microsoft au back pour obtenir un token local.
     * - Si ton back renvoie { accessToken }, on le retourne.
     * - Si ton back pose un cookie httpOnly, le retour peut être vide (204).
     */
    async exchangeForLocalToken(opts?: { useAccessToken?: boolean }): Promise<string | void> {
        const token = await this.microsoftAcquireToken({ useAccessToken: !!opts?.useAccessToken });
        const path = `/auth/login/azure`;
        const data = {
            token,
        };
        const resp = await this.restService.post(path, {}, data);
        return resp?.access_token;
    }
}
